import { useEffect, useState } from "react";
import HeaderMenu from "../sidebar/headermenu";
import { API_STATUS } from "../../constants";
import { EditPostText } from "../../apis/posts/edit_post_text";
import { useNavigate } from "react-router-dom";

export default function EditPostModal({ item, setEdit, reload }) {
    const navigate = useNavigate();
    const [editApi, setEditApi] = useState(API_STATUS);

    // Form state initialized with item values
    const [postText, setText] = useState(item.p_title || "");
    const [adPostType, setAdPostType] = useState(item.ad_post_type || "buy");
    const [adPostLink, setAdPostLink] = useState(item.ad_post_link || "");

    useEffect(() => {
        if (!editApi.isError && !editApi.isLoader && editApi.data != null) {
            setEdit(false);
            reload();
        }
    }, [editApi]);

    const handleSave = () => {
        const payload = {
            pid: item.p_id,
            ad_post: item.ad_post,
        };

        if (item.ad_post === 1) {
            payload.ad_post_type = adPostType;
            payload.ad_post_link = adPostLink;
        } else {
            payload.title = postText;
        }

        EditPostText(payload, setEditApi);
    };

    return (
        <div className="max-lg:!items-start relative mx-auto bg-white shadow-xl rounded-lg w-full dark:bg-dark2">
            {/* Header */}
            <div className="flex px-5 py-3 border-b dark:border-slate-700" style={{ justifyContent: 'space-between' }}>
                <div className="font-semibold text-md dark:text-white">
                    Edit {item.ad_post === 1 ? "Adpost" : "Post"}
                </div>
                <button
                    onClick={() => setEdit(false)}
                    type="button"
                    className="button lg:px-6 bg-secondery"
                >
                    Cancel
                </button>
            </div>

            {/* Form Body */}
            <div className="p-5" style={{width: '460px'}}>
                {item.ad_post === 1 ? (
                    /* ADPOST EDIT FIELDS */
                    <div className="space-y-4 text-sm font-medium">
                        <div>
                            <label className="block mb-2 font-bold text-slate-700 dark:text-slate-200">
                                Action Button Type
                            </label>
                            <div className="flex items-center gap-6">
                                <label className="flex items-center gap-2 cursor-pointer dark:text-white">
                                    <input
                                        type="radio"
                                        name="ad_post_type"
                                        value="buy"
                                        checked={adPostType === "buy"}
                                        onChange={(e) => setAdPostType(e.target.value)}
                                        className="w-4 h-4 text-blue-600"
                                    />
                                    <span>Buy Now</span>
                                </label>
                                <label className="flex items-center gap-2 cursor-pointer dark:text-white">
                                    <input
                                        type="radio"
                                        name="ad_post_type"
                                        value="visit"
                                        checked={adPostType === "visit"}
                                        onChange={(e) => setAdPostType(e.target.value)}
                                        className="w-4 h-4 text-blue-600"
                                    />
                                    <span>Visit</span>
                                </label>
                            </div>
                        </div>

                        <div>
                            <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">
                                Button Link
                            </label>
                            <input
                                type="text"
                                value={adPostLink}
                                onChange={(e) => setAdPostLink(e.target.value)}
                                placeholder="https://example.com"
                                className="w-full form-input border rounded-lg p-2.5 dark:bg-slate-800 dark:text-white dark:border-slate-700"
                            />
                        </div>
                    </div>
                ) : (
                    /* REGULAR POST EDIT FIELDS */
                    <div className="items-start gap-10">
                        <div className="flex-1">
                            <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200 text-sm">
                                Post Title / Description
                            </label>
                            <textarea
                                value={postText}
                                onChange={(e) => setText(e.target.value)}
                                name="postTitle"
                                className="w-full form-input border rounded-lg p-2.5 dark:bg-slate-800 dark:text-white dark:border-slate-700"
                                rows="5"
                                placeholder="Write something..."
                            />
                        </div>
                    </div>
                )}

                {/* Save Button */}
                <div className="flex items-center justify-center gap-4 mt-5">
                    <button
                        onClick={handleSave}
                        type="button"
                        className="button lg:px-10 bg-primary text-white max-md:flex-1"
                    >
                        Save <span className="ripple-overlay"></span>
                    </button>
                </div>
            </div>

            {/* Loading Overlay */}
            {editApi.isLoader && (
                <div
                    role="status"
                    style={{
                        position: 'absolute',
                        top: 0,
                        right: 0,
                        bottom: 0,
                        left: 0,
                        backgroundColor: '#ffffffb8',
                        justifyItems: 'center',
                        alignContent: 'center'
                    }}
                >
                    <svg
                        aria-hidden="true"
                        className="w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-blue-600"
                        viewBox="0 0 100 101"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                            fill="currentColor"
                        />
                        <path
                            d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                            fill="currentFill"
                        />
                    </svg>
                    <span className="sr-only">Loading...</span>
                </div>
            )}
        </div>
    );
}